import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  Box,
  Chip,
  Paper
} from "@mui/material";
import { FaCalendarAlt, FaInfoCircle, FaBarcode, FaChurch } from "react-icons/fa";
import moment from "moment";

const AssetView = ({ currentRecord }) => {
  const formatDate = (dateString) => {
    return dateString ? moment(dateString).format("MMMM DD, YYYY") : "N/A";
  };

  const InfoItem = ({ icon, label, value }) => (
    <Box display="flex" alignItems="center" mb={2}>
      <Box mr={2} color="primary.main">
        {icon}
      </Box>
      <Box>
        <Typography variant="caption" color="textSecondary">
          {label}
        </Typography>
        <Typography variant="body1">{value || "N/A"}</Typography>
      </Box>
    </Box>
  );

  return (
    <Paper elevation={3} sx={{ borderRadius: 0, overflow: "hidden" }}>      
      <CardContent>
        <Grid container spacing={3}>
          {/* Left Column */}
          <Grid item xs={12} md={6}>
            <Box mb={3}>
              <Typography variant="h6" color="primary" gutterBottom>
                Basic Information
              </Typography>
              <Divider sx={{ mb: 2 }} />
              
              <InfoItem 
                icon={<FaBarcode />} 
                label="ITEM CODE" 
                value={currentRecord?.item_code} 
              />
              
              <InfoItem 
                icon={<FaInfoCircle />} 
                label="ASSET NAME" 
                value={currentRecord?.asset_name} 
              />
              
              <InfoItem 
                icon={<FaChurch />} 
                label="CHURCH ID" 
                value={currentRecord?.church_id?.church_name} 
              />
              
              <Box display="flex" alignItems="center" mb={2}>
                <Box mr={2} color="primary.main">
                  <FaInfoCircle />
                </Box>
                <Box>
                  <Typography variant="caption" color="textSecondary">
                    STATUS
                  </Typography>
                  <Box mt={0.5}>
                    <Chip 
                      size="small"
                      label={currentRecord?.status ? "Active" : "Inactive"}
                      color={currentRecord?.status ? "success" : "error"}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
          
          {/* Right Column */}
          <Grid item xs={12} md={6}>
            <Box mb={3}>
              <Typography variant="h6" color="primary" gutterBottom>
                Additional Information
              </Typography>
              <Divider sx={{ mb: 2 }} />
              
              <InfoItem 
                icon={<FaInfoCircle />} 
                label="DESCRIPTION" 
                value={currentRecord?.description} 
              />
              
              <InfoItem 
                icon={<FaCalendarAlt />} 
                label="CREATED AT" 
                value={formatDate(currentRecord?.createdAt)} 
              />
              
              <InfoItem 
                icon={<FaCalendarAlt />} 
                label="UPDATED AT" 
                value={formatDate(currentRecord?.updatedAt)} 
              />
              
              <InfoItem 
                icon={<FaInfoCircle />} 
                label="CREATED BY" 
                value={currentRecord?.created_by?.first_name + " " + currentRecord?.created_by?.last_name} 
              />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Paper>
  );
};

export default AssetView;
